const EASINGS = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  easeInQuad: "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
  easeOutQuad: "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
  easeInOutQuad: "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
  easeInCubic: "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
  easeOutCubic: "cubic-bezier(0.215, 0.610, 0.355, 1.000)",
  easeInOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
  easeInQuart: "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
  easeOutQuart: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  easeInOutQuart: "cubic-bezier(0.770, 0.000, 0.175, 1.000)",
  easeInQuint: "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
  easeOutQuint: "cubic-bezier(0.230, 1.000, 0.320, 1.000)",
  easeInOutQuint: "cubic-bezier(0.860, 0.000, 0.070, 1.000)",
  easeInSine: "cubic-bezier(0.470, 0.000, 0.745, 0.715)",
  easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
  easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
  easeInExpo: "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
  easeOutExpo: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
  easeInOutExpo: "cubic-bezier(1.000, 0.000, 0.000, 1.000)",
  easeInCirc: "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
  easeOutCirc: "cubic-bezier(0.075, 0.820, 0.165, 1.000)",
  easeInOutCirc: "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
  easeInBack: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
  easeOutBack: "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
  easeInOutBack: "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
};

const DEFAULT_DURATION = 400;
const DEFAULT_EASING = EASINGS.easeOutSine;

function getDuration(duration) {
  const numericDuration = Number(duration);
  return Number.isFinite(numericDuration) && numericDuration > 0 ? numericDuration : DEFAULT_DURATION;
}

function getEasing(easing) {
  return (easing && EASINGS[easing]) || DEFAULT_EASING;
}

function invokeComplete(element, options) {
  if (options && typeof options.complete === "function") {
    options.complete.call(element);
  }
}

function temporarilyDisableMinHeight(element) {
  if (!element) return () => {};
  const previousMinHeight = element.style.minHeight;
  const hadInlineMinHeight = previousMinHeight && previousMinHeight.length > 0;
  element.style.minHeight = "0px";
  return () => {
    if (hadInlineMinHeight) {
      element.style.minHeight = previousMinHeight;
    } else {
      element.style.removeProperty("min-height");
    }
  };
}

function slideUp(element, options = {}) {
  if (!element) return;

  const duration = getDuration(options.duration);
  const easing = getEasing(options.easing);
  const fadeOut = Boolean(options.fadeOut);
  const startHeight = element.offsetHeight;
  let restoreMinHeight = () => {};

  element.style.transitionProperty = fadeOut ? "opacity, height, margin, padding" : "height, margin, padding";
  element.style.transitionDuration = `${duration}ms`;
  element.style.transitionTimingFunction = easing;
  element.style.boxSizing = "border-box";
  element.style.height = `${startHeight}px`;
  restoreMinHeight = temporarilyDisableMinHeight(element);
  element.offsetHeight;
  element.style.overflow = "hidden";
  element.style.willChange = "height, margin, padding";
  element.style.height = "0";
  element.style.paddingTop = "0";
  element.style.paddingBottom = "0";
  element.style.marginTop = "0";
  element.style.marginBottom = "0";
  if (fadeOut) element.style.opacity = "0";

  window.setTimeout(() => {
    element.style.display = "none";
    element.style.removeProperty("height");
    if (fadeOut) element.style.removeProperty("opacity");
    element.style.removeProperty("padding-top");
    element.style.removeProperty("padding-bottom");
    element.style.removeProperty("margin-top");
    element.style.removeProperty("margin-bottom");
    element.style.removeProperty("overflow");
    element.style.removeProperty("will-change");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
    element.style.removeProperty("transition-timing-function");
    restoreMinHeight();
    invokeComplete(element, options);
  }, duration);
}

function slideDown(element, options = {}) {
  if (!element) return;

  const duration = getDuration(options.duration);
  const easing = getEasing(options.easing);
  const fade = Boolean(options.fade);

  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";

  element.style.display = display;
  const height = element.offsetHeight;
  const restoreMinHeight = temporarilyDisableMinHeight(element);
  element.style.overflow = "hidden";
  element.style.willChange = "height, margin, padding";
  element.style.height = "0";
  element.style.paddingTop = "0";
  element.style.paddingBottom = "0";
  element.style.marginTop = "0";
  element.style.marginBottom = "0";
  element.offsetHeight;
  element.style.boxSizing = "border-box";
  element.style.transitionProperty = fade ? "opacity, height, margin, padding" : "height, margin, padding";
  element.style.transitionDuration = `${duration}ms`;
  element.style.transitionTimingFunction = easing;
  element.style.height = `${height}px`;
  element.style.removeProperty("padding-top");
  element.style.removeProperty("padding-bottom");
  element.style.removeProperty("margin-top");
  element.style.removeProperty("margin-bottom");
  if (fade) element.style.opacity = "1";

  window.setTimeout(() => {
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("will-change");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
    element.style.removeProperty("transition-timing-function");
    if (fade) element.style.removeProperty("opacity");
    restoreMinHeight();
    invokeComplete(element, options);
  }, duration);
}

function slideToggle(element, options = {}) {
  if (!element) return;
  const display = window.getComputedStyle(element).display;
  if (display === "none") {
    slideDown(element, options);
  } else {
    slideUp(element, options);
  }
}

function slideUpFade(element, options = {}) {
  slideUp(element, { ...options, fadeOut: true });
}

function slideDownFade(element, options = {}) {
  slideDown(element, { ...options, fade: true });
}

function fadeIn(element, options = {}) {
  if (!element) return;

  const duration = getDuration(options.duration);
  const easing = getEasing(options.easing);

  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";

  element.style.opacity = "0";
  element.style.display = display;
  element.style.willChange = "opacity";
  element.style.transitionProperty = "opacity";
  element.style.transitionDuration = `${duration}ms`;
  element.style.transitionTimingFunction = easing;

  window.setTimeout(() => {
    element.style.opacity = "1";
  }, 10);

  window.setTimeout(() => {
    element.style.removeProperty("opacity");
    element.style.removeProperty("will-change");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
    element.style.removeProperty("transition-timing-function");
    invokeComplete(element, options);
  }, duration + 10);
}

function fadeOut(element, options = {}) {
  if (!element) return;

  const duration = getDuration(options.duration);
  const easing = getEasing(options.easing);

  element.style.willChange = "opacity";
  element.style.transitionProperty = "opacity";
  element.style.transitionDuration = `${duration}ms`;
  element.style.transitionTimingFunction = easing;
  element.style.opacity = "0";

  window.setTimeout(() => {
    element.style.display = "none";
    element.style.removeProperty("opacity");
    element.style.removeProperty("will-change");
    element.style.removeProperty("transition-duration");
    element.style.removeProperty("transition-property");
    element.style.removeProperty("transition-timing-function");
    invokeComplete(element, options);
  }, duration);
}

const Effects = {
  slideUp,
  slideDown,
  slideToggle,
  slideUpFade,
  slideDownFade,
  fadeIn,
  fadeOut,
};

export default Effects;

function addDelegatedClickListener(selector, handler) {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger) return;
    handler(trigger, event);
  });
}

function getTargetElement(selector) {
  if (!selector) return null;
  return document.querySelector(selector);
}

function toOffset(value) {
  const numericOffset = Number(value);
  return Number.isFinite(numericOffset) ? numericOffset : 0;
}

addDelegatedClickListener('[data-action="slide"]', (trigger) => {
  const upElement = getTargetElement(trigger.getAttribute("data-target-up"));
  const downElement = getTargetElement(trigger.getAttribute("data-target-down"));
  if (!upElement || !downElement) return;

  Effects.slideDown(downElement, {
    duration: 400,
    easing: "easeOut",
  });

  Effects.slideUp(upElement, {
    duration: 400,
    easing: "easeOut",
  });
});

addDelegatedClickListener('[data-action="slideDown"]', (trigger) => {
  const targetElement = getTargetElement(trigger.dataset.target);
  if (!targetElement) return;

  const autofocus = trigger.dataset.autofocus || false;
  const scrollIntoView = trigger.dataset.scrollIntoView || false;
  const scrollOffset = toOffset(trigger.dataset.scrollOffset);

  Effects.slideDown(targetElement, {
    duration: trigger.dataset.duration || 400,
    easing: trigger.dataset.easing || "easeOut",
    complete() {
      if (autofocus) {
        const focusElement = targetElement.querySelector(autofocus);
        if (focusElement) {
          focusElement.focus();
        }
      }
      if (scrollIntoView && typeof Viewport !== "undefined") {
        Viewport.scrollIntoView(targetElement, { offset: scrollOffset });
      }
    },
  });
});

addDelegatedClickListener('[data-action="slideUp"]', (trigger) => {
  const targetElement = getTargetElement(trigger.dataset.target);
  if (!targetElement) return;

  const autofocus = trigger.dataset.autofocus || false;
  const scrollIntoView = trigger.dataset.scrollIntoView || false;
  const scrollOffset = toOffset(trigger.dataset.scrollOffset);

  Effects.slideUp(targetElement, {
    duration: trigger.dataset.duration || 400,
    easing: trigger.dataset.easing || "easeOut",
    complete() {
      if (autofocus) {
        const focusElement = targetElement.querySelector(autofocus);
        if (focusElement) {
          focusElement.focus();
        }
      }
      if (scrollIntoView && typeof Viewport !== "undefined") {
        Viewport.scrollIntoView(targetElement, { offset: scrollOffset });
      }
    },
  });
});

addDelegatedClickListener('[data-action="slideToggle"]', (trigger) => {
  const targetElement = getTargetElement(trigger.dataset.target);
  if (!targetElement) return;

  const autofocus = trigger.dataset.autofocus || false;
  const scrollIntoView = trigger.dataset.scrollIntoView || false;
  const scrollOffset = toOffset(trigger.dataset.scrollOffset);

  Effects.slideToggle(targetElement, {
    duration: trigger.dataset.duration || 400,
    easing: trigger.dataset.easing || "easeOut",
    complete() {
      if (autofocus) {
        const focusElement = targetElement.querySelector(autofocus);
        if (focusElement) {
          focusElement.focus();
        }
      }
      if (scrollIntoView && typeof Viewport !== "undefined") {
        Viewport.scrollIntoView(targetElement, { offset: scrollOffset });
      }
    },
  });
});
